// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"602a7e32","2962":"602a7e32"}[chunkId] + ".chunk.css";
};